import { isLDHosted } from './isLDHosted';
import type { MetricDataSource } from './types';

/**
 * True when a metric's `eventKey` is just its Warehouse Native data source key standing in for an
 * event key the user never supplied. WHN metrics report no events to LaunchDarkly, so there is no
 * real event key to display or copy.
 *
 * Takes an object rather than positional args (unlike `isLDHosted`) because both fields are
 * optional strings — positionally they are trivial to transpose.
 */
export const isImplicitWHNEventKey = ({
  eventKey,
  dataSourceKey,
}: {
  eventKey?: string;
  dataSourceKey?: MetricDataSource['key'];
}) => !!dataSourceKey && !isLDHosted(dataSourceKey) && eventKey === dataSourceKey;
